import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatSnackBar } from '@angular/material';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { NgbCalendar, NgbDate, NgbDateParserFormatter, NgbInputDatepicker } from '@ng-bootstrap/ng-bootstrap';
import { AdminService } from 'src/app/admin.service';
import { PrefferedListsComponent } from '../preffered-lists/preffered-lists.component';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.css']
})
export class ReportsComponent implements OnInit {
  filtercustomer: string = "all";
  reportsForm1: FormGroup;
  referraluserForm :FormGroup;
  providerForm: FormGroup;
  bookingsForm: FormGroup;
  buysellbookingsForm: FormGroup;
  referralForm: FormGroup;
  bankDetailsForm: FormGroup;
  dateRange: any;
  fileName: string = "";
  bsInlineValue = new Date();
  bsInlineRangeValue: Date[];
  maxDate: any = new Date();
  maxDate1: any = new Date();
  taskStatus: string = "All"
  date = null;
  selectedCat: Array<any> = [];
  selectedCompCat : Array<any> = [];
  statesArray: Array<any> = ["All",
    "Afghanistan",
    "Aland Islands",
    "Albania",
    "Algeria",
    "AmericanSamoa",
    "Andorra",
    "Angola",
    "Anguilla",
    "Antigua and Barbuda",
    "Argentina",
    "Armenia",
    "Aruba",
    "Australia",
    "Austria",
    "Azerbaijan",
    "Bahamas",
    "Bahrain",
    "Bangladesh",
    "Barbados",
    "Belarus",
    "Belgium",
    "Belize",
    "Benin",
    "Bermuda",
    "Bhutan",
    "Bolivia Plurinational State of",
    "Bosnia and Herzegovina",
    "Botswana",
    "Brazil",
    "British Indian Ocean Territory",
    "Brunei Darussalam",
    "Bulgaria",
    "Burkina Faso",
    "Burundi",
    "Cambodia",
    "Cameroon",
    "Canada",
    "Cape Verde",
    "Cayman Islands",
    "Central African Republic",
    "Chad",
    "Chile",
    "China",
    "Christmas Island",
    "Cocos (Keeling) Islands",
    "Colombia",
    "Comoros",
    "Congo",
    "Congo The Democratic Republic of the Congo",
    "Cook Islands",
    "Costa Rica",
    "Cote d'Ivoire",
    "Croatia",
    "Cuba",
    "Cyprus",
    "Czech Republic",
    "Denmark",
    "Djibouti",
    "Dominica",
    "Dominican Republic",
    "Ecuador",
    "Egypt",
    "El Salvador",
    "Equatorial Guinea",
    "Eritrea",
    "Estonia",
    "Ethiopia",
    "Falkland Islands (Malvinas)",
    "Faroe Islands",
    "Fiji",
    "Finland",
    "France",
    "French Guiana",
    "French Polynesia",
    "Gabon",
    "Gambia",
    "Georgia",
    "Germany",
    "Ghana",
    "Gibraltar",
    "Greece",
    "Greenland",
    "Grenada",
    "Guadeloupe",
    "Guam",
    "Guatemala",
    "Guernsey",
    "Guinea",
    "Guinea-Bissau",
    "Guyana",
    "Haiti",
    "Holy See (Vatican City State)",
    "Honduras",
    "Hong Kong",
    "Hungary",
    "Iceland",
    "India",
    "Indonesia",
    "Iran Islamic Republic of Persian Gulf",
    "Iraq",
    "Ireland",
    "Isle of Man",
    "Israel",
    "Italy",
    "Jamaica",
    "Japan",
    "Jersey",
    "Jordan",
    "Kazakhstan",
    "Kenya",
    "Kiribati",
    "Korea Democratic People's Republic of Korea",
    "Korea Republic of South Korea",
    "Kuwait",
    "Kyrgyzstan",
    "Laos",
    "Latvia",
    "Lebanon",
    "Lesotho",
    "Liberia",
    "Libyan Arab Jamahiriya",
    "Liechtenstein",
    "Lithuania",
    "Luxembourg",
    "Macao",
    "Macedonia",
    "Madagascar",
    "Malawi",
    "Malaysia",
    "Maldives",
    "Mali",
    "Malta",
    "Marshall Islands",
    "Martinique",
    "Mauritania",
    "Mauritius",
    "Mayotte",
    "Mexico",
    "Micronesia Federated States of Micronesia",
    "Moldova",
    "Monaco",
    "Mongolia",
    "Montenegro",
    "Montserrat",
    "Morocco",
    "Mozambique",
    "Myanmar",
    "Namibia",
    "Nauru",
    "Nepal",
    "Netherlands",
    "New Caledonia",
    "New Zealand",
    "Nicaragua",
    "Niger",
    "Nigeria",
    "Niue",
    "Norfolk Island",
    "Northern Mariana Islands",
    "Norway",
    "Oman",
    "Pakistan",
    "Palau",
    "Palestinian Territory Occupied",
    "Panama",
    "Papua New Guinea",
    "Paraguay",
    "Peru",
    "Philippines",
    "Poland",
    "Portugal",
    "Puerto Rico",
    "Qatar",
    "Romania",
    "Russia",
    "Rwanda",
    "Reunion",
    "Saint Barthelemy",
    "Saint Helena Ascension and Tristan Da Cunha",
    "Saint Kitts and Nevis",
    "Saint Lucia",
    "Saint Martin",
    "Saint Pierre and Miquelon",
    "Saint Vincent and the Grenadines",
    "Samoa",
    "San Marino",
    "Sao Tome and Principe",
    "Saudi Arabia",
    "Senegal",
    "Serbia",
    "Seychelles",
    "Sierra Leone",
    "Singapore",
    "Slovakia",
    "Slovenia",
    "Solomon Islands",
    "Somalia",
    "South Africa",
    "South Sudan",
    "Spain",
    "Sri Lanka",
    "Sudan",
    "Suriname",
    "Svalbard and Jan Mayen",
    "Swaziland",
    "Sweden",
    "Switzerland",
    "Syrian Arab Republic",
    "Taiwan",
    "Tajikistan",
    "Tanzania United Republic of Tanzania",
    "Thailand",
    "Timor-Leste",
    "Togo",
    "Tokelau",
    "Tonga",
    "Trinidad and Tobago",
    "Tunisia",
    "Turkey",
    "Turkmenistan",
    "Turks and Caicos Islands",
    "Tuvalu",
    "Uganda",
    "Ukraine",
    "United Arab Emirates",
    "United Kingdom",
    "United States",
    "Uruguay",
    "Uzbekistan",
    "Vanuatu",
    "Venezuela Bolivarian Republic of Venezuela",
    "Vietnam",
    "Virgin Islands British",
    "Virgin Islands U.S.",
    "Wallis and Futuna",
    "Yemen",
    "Zambia",
    "Zimbabwe"]
  customerDetailsLink: string = "";
  bookingStatus: string = "All";
  buyBookingStatus: string = "All";
  stateName: string = "All"
  @ViewChild('t', { static: false }) datePicker: NgbInputDatepicker;
  hoveredDate: NgbDate | null = null;
  fromDate: NgbDate | null;
  toDate: NgbDate | null;
  constructor(private adminService: AdminService, private dialog: MatDialog,
    private fb: FormBuilder, private snackBar: MatSnackBar, private calendar: NgbCalendar,
    public formatter: NgbDateParserFormatter, private sanitizer: DomSanitizer, private router: Router) { }

  ngOnInit() {
    let adminType = sessionStorage.getItem('isMainAdmin');
    // console.log(this.maxDate);
    if (adminType == "0") {
      this.openSnackBar("Your not a System administrator to access this page", "");
      this.router.navigateByUrl('/admin/allBookings');
    }
    this.maxDate.setDate(this.maxDate.getDate() + 7);
    this.bsInlineRangeValue = [this.bsInlineValue, this.maxDate];
    this.reportsForm1 = this.fb.group({
      dateRange: ["", Validators.required]
    })
    this.providerForm = this.fb.group({
      dateRange: ["", Validators.required]
    })
    this.bookingsForm = this.fb.group({
      dateRange: ["", Validators.required]
    })
    this.buysellbookingsForm = this.fb.group({
      dateRange: ["", Validators.required]
    })
    this.bankDetailsForm = this.fb.group({
      dateRange: ["", Validators.required]
    })
    this.referralForm = this.fb.group({
      dateRange: ["", Validators.required]
    })
    this.referraluserForm = this.fb.group({
      dateRange: ["", Validators.required]
    })
  }

  changeView(event) {
    this.filtercustomer = event.value;
    if (this.filtercustomer == "poster") {

    } else if (this.filtercustomer == "provider") {

    } else {
    }
  }
  selectState(state) {
    this.stateName = state;
  }
  bookingFilter(status1) {
    this.bookingStatus = status1
  }
  buySellbookingFilter(status) {
    this.buyBookingStatus = status;
  }
  //message alerts showing
  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 3000
    });
  }

  getFilteredReport1() {
    let frmDate = new Date(this.reportsForm1.value.dateRange[0]).getTime();
    let toDate = new Date(this.reportsForm1.value.dateRange[1]).getTime();
    console.log(this.reportsForm1.value.dateRange[0]);
    frmDate = new Date(this.reportsForm1.value.dateRange[0]).setHours(0, 0, 0, 0);
    toDate = new Date(this.reportsForm1.value.dateRange[1]).setHours(23, 59, 59, 999);
    console.log(frmDate);
    let obj = {
      reportType: "Customer",
      fromDate: "" + frmDate,
      toDate: "" + toDate,
      State: this.stateName
    }
    this.fileName = "customerReport.csv";
    this.getReports(obj);
    // console.log(this.reportsForm1.value.startDate[0], this.reportsForm1.value.startDate[1]);
  }
  getAllDeveloperReport() {
    let frmDate = new Date("01/01/2022").getTime();
    let toDate = new Date().getTime();

    // frmDate = new Date(this.reportsForm1.value.dateRange[0]).setHours(0, 0, 0, 0);
    // toDate = new Date(this.reportsForm1.value.dateRange[1]).setHours(23, 59, 59, 999);
    let obj = {
      reportType: "Customer",
      fromDate: "" + frmDate,
      toDate: "" + toDate,
      State: "All"
    }
    console.log(obj);
    this.fileName = "DeveloperDetails.csv";
    this.getReports(obj);
    // console.log(this.reportsForm1.value.startDate[0], this.reportsForm1.value.startDate[1]);
  }

  getproviderDetails() {
    let frmDate = new Date(this.providerForm.value.dateRange[0]).getTime();
    let toDate = new Date(this.providerForm.value.dateRange[1]).getTime();

    frmDate = new Date(this.providerForm.value.dateRange[0]).setHours(0, 0, 0, 0);
    toDate = new Date(this.providerForm.value.dateRange[1]).setHours(23, 59, 59, 999);
    let obj = {
      reportType: "Provider",
      fromDate: "" + frmDate,
      toDate: "" + toDate,
      State: this.stateName
    }
    this.fileName = new Date(this.providerForm.value.dateRange[0]).toLocaleDateString() + "-" + new Date(this.providerForm.value.dateRange[1]).toLocaleDateString() + "providerReport.csv";
    this.getReports(obj)
  }
  getAllCompanyReport() {
    let frmDate = new Date("01/01/2022").getTime();
    let toDate = new Date().getTime();

    // frmDate = new Date(this.providerForm.value.dateRange[0]).setHours(0, 0, 0, 0);
    // toDate = new Date(this.providerForm.value.dateRange[1]).setHours(23, 59, 59, 999);
    let obj = {
      reportType: "Provider",
      fromDate: "" + frmDate,
      toDate: "" + toDate,
      State: "All"
    }
    this.fileName = "AllCompanyUsersReport.csv";
    this.getReports(obj)
  }
  getBookings() {
    let frmDate = new Date(this.bookingsForm.value.dateRange[0]).getTime();
    let toDate = new Date(this.bookingsForm.value.dateRange[1]).getTime();
    frmDate = new Date(this.bookingsForm.value.dateRange[0]).setHours(0, 0, 0, 0);
    toDate = new Date(this.bookingsForm.value.dateRange[1]).setHours(23, 59, 59, 999);
    let obj = {
      reportType: "Bookings",
      reportStatus: this.bookingStatus,
      fromDate: "" + frmDate,
      toDate: "" + toDate,
      State: this.stateName
    }
    this.fileName = "bookingsReport.csv";
    this.getReports(obj)
  }
  getBuyBookings() {
    let frmDate = new Date(this.buysellbookingsForm.value.dateRange[0]).getTime();
    let toDate = new Date(this.buysellbookingsForm.value.dateRange[1]).getTime();
    frmDate = new Date(this.buysellbookingsForm.value.dateRange[0]).setHours(0, 0, 0, 0);
    toDate = new Date(this.buysellbookingsForm.value.dateRange[1]).setHours(23, 59, 59, 999);
    let obj = {
      reportType: "BuySell-Bookings",
      reportStatus: this.buyBookingStatus,
      fromDate: "" + frmDate,
      toDate: "" + toDate,
      State: this.stateName
    }
    this.fileName = "buybookingsReport.csv";
    this.getReports(obj)
  }
  getReferrals() {
    let frmDate = new Date(this.referralForm.value.dateRange[0]).getTime();
    let toDate = new Date(this.referralForm.value.dateRange[1]).getTime();

    frmDate = new Date(this.referralForm.value.dateRange[0]).setHours(0, 0, 0, 0);
    toDate = new Date(this.referralForm.value.dateRange[1]).setHours(23, 59, 59, 999);
    let obj = {
      reportType: "Referral",
      fromDate: "" + frmDate,
      toDate: "" + toDate,
      State: "All"
    }
    this.fileName = "referralReport.csv";
    this.getReports(obj)
  }
  getAllRefferralReport(){
    let frmDate = new Date("01/01/2022").getTime();
    let toDate = new Date().getTime();

    // frmDate = new Date(this.reportsForm1.value.dateRange[0]).setHours(0, 0, 0, 0);
    // toDate = new Date(this.reportsForm1.value.dateRange[1]).setHours(23, 59, 59, 999);
    let obj = {
      reportType:"ReferralUsers",
      fromDate: "" + frmDate,
      toDate: "" + toDate,
      State: this.stateName
    }
    this.fileName = "ReferralUsers_"+this.stateName+".csv";
    this.getReports(obj);
  }
  getFilteredreferralUsersReport1(){
    let frmDate = new Date(this.referraluserForm.value.dateRange[0]).getTime();
    let toDate = new Date(this.referraluserForm.value.dateRange[1]).getTime();

    frmDate = new Date(this.referraluserForm.value.dateRange[0]).setHours(0, 0, 0, 0);
    toDate = new Date(this.referraluserForm.value.dateRange[1]).setHours(23, 59, 59, 999);
    let obj = {
      reportType: "ReferralUsers",
      fromDate: "" + frmDate,
      toDate: "" + toDate,
      State: this.stateName
    }
    this.fileName = new Date(this.referraluserForm.value.dateRange[0]).toLocaleDateString() + "-" + new Date(this.referraluserForm.value.dateRange[1]).toLocaleDateString() + "FilterReferralUsers_"+this.stateName+".csv";
    this.getReports(obj)
  }
  openCategories() {
    let dailogRef = this.dialog.open(PrefferedListsComponent, {
      panelClass: "col-md-3",
      hasBackdrop: true,
      disableClose: true,
      data: { selected: this.selectedCat },
    });
    dailogRef.afterClosed().subscribe((res) => {
      if (res.length) {
        this.selectedCat = [...res];
        let selctCat = [];
        for(let i=0; i< this.selectedCat.length; i++){
          selctCat.push(this.selectedCat[i].categoryName);
        }
        let obj = {
            "Categories" :selctCat,
            "isSelf" : true
          }
          this.getCategoryDownlodReport(obj)
      } else {
      }
    });
  }
  openCompCategories(){
    let dailogRef = this.dialog.open(PrefferedListsComponent, {
      panelClass: "col-md-3",
      hasBackdrop: true,
      disableClose: true,
      data: { selected: this.selectedCompCat },
    });
    dailogRef.afterClosed().subscribe((res) => {
      if (res.length) {
        this.selectedCompCat = [...res];
        let selctCat = [];
        for(let i=0; i< this.selectedCompCat.length; i++){
          selctCat.push(this.selectedCompCat[i].categoryName);
        }
        let obj = {
            "Categories" :selctCat,
            "isSelf" : false
          }
          this.getCategoryDownlodReport(obj)
      } else {
      }
    });
  }
  getCategoryDownlodReport(obj){
    this.adminService.showLoader.next(true);
    let token = sessionStorage.getItem('token');
    let usname = "developers";
    if(!obj.isSelf){
      usname="Company"
    }
    this.fileName = "Categorywise_"+usname+"users.csv";
    this.adminService.downloadCategoryReports(obj, token).subscribe((posRes) => {
      this.adminService.showLoader.next(false);
      var blob = new Blob([posRes]);
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveBlob(blob, this.fileName);
      }
      else {
        var a = window.document.createElement("a");

        a.href = window.URL.createObjectURL(blob);
        a.download = this.fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }
    }, (err: HttpErrorResponse) => {
      if (err.error instanceof Error) {
        console.warn("Client Error", err.message);
      } else {
        console.warn("Server Error", err.message);
      }
    })
  }
  getReports(obj) {
    this.adminService.showLoader.next(true);
    let token = sessionStorage.getItem('token')
    this.adminService.downloadReports(obj, token).subscribe((posRes) => {
      this.adminService.showLoader.next(false);
      var blob = new Blob([posRes]);
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveBlob(blob, this.fileName);
      }
      else {
        var a = window.document.createElement("a");

        a.href = window.URL.createObjectURL(blob);
        a.download = this.fileName;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }
    }, (err: HttpErrorResponse) => {
      if (err.error instanceof Error) {
        console.warn("Client Error", err.message);
      } else {
        console.warn("Server Error", err.message);
      }
    })
  }
  getAllAdvertiseReport(){
    let frmDate = new Date("01/01/2022").getTime();
    let toDate = new Date().getTime();

    // frmDate = new Date(this.providerForm.value.dateRange[0]).setHours(0, 0, 0, 0);
    // toDate = new Date(this.providerForm.value.dateRange[1]).setHours(23, 59, 59, 999);
    let obj = {
      reportType: "Advatages",
      fromDate: "" + frmDate,
      toDate: "" + toDate,
      State: "All"
    }
    this.fileName = "AllAdvertiseUsersReport.csv";
    this.getReports(obj)
  }
  getBankDetails() {
    let frmDate = new Date(this.bankDetailsForm.value.dateRange[0]).getTime();
    let toDate = new Date(this.bankDetailsForm.value.dateRange[1]).getTime();
    frmDate = new Date(this.bankDetailsForm.value.dateRange[0]).setHours(0, 0, 0, 0);
    toDate = new Date(this.bankDetailsForm.value.dateRange[1]).setHours(23, 59, 59, 999);
    let obj = {
      reportType: "Bookings-Details",
      reportStatus: "All",
      fromDate: "" + frmDate,
      toDate: "" + toDate,
      State: "All"
    }
    this.fileName = "booking-details.csv";
    this.getReports(obj)
  }
}
